/** 用户预置标签关联的真实查询与写入；成功后等待详情重拉，避免以请求意图代替持有状态。 */
import {
  type UserTagAssignmentResponse,
  type UserTagDto,
  isPresetUserTagKey,
} from '@novel-admin/shared';
import { onlineManager, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiRequest, apiRequestOffsetPaged } from '~/api/client';

export function useUserPresetTagDefinitions() {
  return useQuery({
    queryKey: ['user-preset-tag-definitions'],
    queryFn: async () => {
      // @real — 完整翻页，避免预置定义被新建标签挤到后页。
      const tags: UserTagDto[] = [];
      let page = 1;
      while (true) {
        const result = await apiRequestOffsetPaged<UserTagDto>({
          method: 'GET',
          path: '/api/v1/user-tags',
          query: { page, limit: 200 },
        });
        tags.push(...result.data.filter((tag) => isPresetUserTagKey(tag.tag_key)));
        if (!result.hasMore) return tags;
        page += 1;
      }
    },
  });
}

export function useUserPresetTagAssignment(userId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    // 预置标签包含审核/内测能力，人工授权不得离线延迟执行或在未知结果后自动重放。
    networkMode: 'always',
    retry: false,
    mutationFn: ({ tagId, isAssigned }: { tagId: string; isAssigned: boolean }) => {
      if (!onlineManager.isOnline())
        throw new Error('网络不可用，本次标签操作未发送；恢复后请重新确认并提交。');
      return apiRequest<UserTagAssignmentResponse>({
        method: isAssigned ? 'PUT' : 'DELETE',
        path: `/api/v1/users/${userId}/tags/${tagId}`,
      });
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['user-detail', userId] }),
        queryClient.invalidateQueries({ queryKey: ['users', 'page'] }),
      ]);
    },
  });
}
